import React, { useState } from 'react';
// import '../styles/ElementorSidebar.css';

const ElementorSidebar = ({ onAddSection, onAddWidget, selectedSection, selectedElement }) => {
  const [activeTab, setActiveTab] = useState('sections');
  
  // Section Templates with Elementor-style SVG icons
  const sectionTemplates = [
    {
      id: "one-column",
      name: "One Column",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="6" width="16" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      preview: "Single column layout",
    },
    {
      id: "two-column",
      name: "Two Columns",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="6" width="9" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="13" y="6" width="9" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      preview: "Two equal columns",
    },
    {
      id: "three-column",
      name: "Three Columns",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="6" width="6" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="9" y="6" width="6" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="16" y="6" width="6" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      preview: "Three equal columns",
    },
    {
      id: "two-column-unequal",
      name: "Two Columns (33/66)",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="6" width="6" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="10" y="6" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      preview: "Two columns (33% / 66%)",
    },
    {
      id: "two-column-unequal-reverse",
      name: "Two Columns (66/33)",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="6" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="16" y="6" width="6" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      preview: "Two columns (66% / 33%)",
    },
    {
      id: "four-column",
      name: "Four Columns",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="6" width="4.5" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="7.5" y="6" width="4.5" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="13" y="6" width="4.5" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="18" y="6" width="4" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      preview: "Four equal columns",
    },
  ];

  // Widgets with Elementor-style SVG icons
  const widgets = [
    // Basic Elements
    { 
      id: 'heading', 
      name: 'Heading', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 4h14v2h-5v10h-2V6H5V4H3z"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'text', 
      name: 'Text Editor', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M4 4h12v2H4V4zm0 4h12v2H4V8zm0 4h8v2H4v-2z"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'paragraph', 
      name: 'Paragraph', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M4 4h12v2H4V4zm0 3h10v2H4V7zm0 3h12v2H4v-2zm0 3h8v2H4v-2z"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'button', 
      name: 'Button', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="7" width="14" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M7 10h6" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'link', 
      name: 'Link', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M8 10h4M10 8v4" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12 4h3a3 3 0 013 3v3a3 3 0 01-3 3h-3M8 16H5a3 3 0 01-3-3v-3a3 3 0 013-3h3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'icon', 
      name: 'Icon', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="10" cy="10" r="6" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'quote', 
      name: 'Quote', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M6 5h2v6H6V5zm6 0h2v6h-2V5z" fill="currentColor"/>
          <path d="M4 13h12v2H4v-2z" fill="currentColor"/>
        </svg>
      ),
      category: 'basic' 
    },
    { 
      id: 'list', 
      name: 'List', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="5" cy="6" r="1.5" fill="currentColor"/>
          <circle cx="5" cy="10" r="1.5" fill="currentColor"/>
          <circle cx="5" cy="14" r="1.5" fill="currentColor"/>
          <line x1="9" y1="6" x2="15" y2="6" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="9" y1="10" x2="15" y2="10" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="9" y1="14" x2="15" y2="14" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'basic' 
    },

    // Media Elements
    { 
      id: 'image', 
      name: 'Image', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="3" width="16" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="7" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M2 14l4-4 3 3 5-5 4 4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'media' 
    },
    { 
      id: 'video', 
      name: 'Video', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="4" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M16 7l3-2v10l-3-2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'media' 
    },
    { 
      id: 'audio', 
      name: 'Audio', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M8 5v10l6-5-6-5z" fill="currentColor"/>
          <path d="M15 8a3 3 0 010 4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'media' 
    },
    { 
      id: 'gallery', 
      name: 'Gallery', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="2" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="2" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="2" y="11" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="11" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'media' 
    },
    { 
      id: 'slider', 
      name: 'Image Slider', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="4" width="16" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="7" cy="10" r="1.5" fill="currentColor"/>
          <circle cx="10" cy="10" r="1.5" fill="currentColor"/>
          <circle cx="13" cy="10" r="1.5" fill="currentColor"/>
        </svg>
      ),
      category: 'media' 
    },
    { 
      id: 'map', 
      name: 'Google Maps', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10 2C6.13 2 3 5.13 3 9c0 5 7 9 7 9s7-4 7-9c0-3.87-3.13-7-7-7z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="10" cy="9" r="2" fill="currentColor"/>
        </svg>
      ),
      category: 'media' 
    },

    // Layout Elements
    { 
      id: 'divider', 
      name: 'Divider', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <line x1="3" y1="10" x2="17" y2="10" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="10" cy="10" r="2" fill="currentColor"/>
        </svg>
      ),
      category: 'layout' 
    },
    { 
      id: 'spacer', 
      name: 'Spacer', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <line x1="5" y1="5" x2="15" y2="5" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="5" y1="15" x2="15" y2="15" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="10" y1="7" x2="10" y2="13" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'layout' 
    },
    { 
      id: 'accordion', 
      name: 'Accordion', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="3" width="14" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="3" y="8.5" width="14" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="3" y="14" width="14" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M10 4.5L8 6.5l2 2M10 14.5l-2-2 2-2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'layout' 
    },
    { 
      id: 'tabs', 
      name: 'Tabs', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="5" width="5" height="3" rx="1" fill="currentColor"/>
          <rect x="9" y="5" width="9" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="2" y="10" width="16" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'layout' 
    },

    // Dynamic Elements
    { 
      id: 'counter', 
      name: 'Counter', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <text x="10" y="14" textAnchor="middle" fontSize="12" fontWeight="bold">123</text>
          <path d="M5 16h10" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'dynamic' 
    },
    { 
      id: 'progress-bar', 
      name: 'Progress Bar', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="8" width="16" height="4" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="2" y="8" width="10" height="4" rx="2" fill="currentColor" opacity="0.5"/>
        </svg>
      ),
      category: 'dynamic' 
    },
    { 
      id: 'form', 
      name: 'Form', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="3" width="14" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <line x1="6" y1="7" x2="14" y2="7" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="6" y1="10" x2="12" y2="10" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="6" y1="13" x2="10" y2="13" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'dynamic' 
    },
    { 
      id: 'social-share', 
      name: 'Social Share', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="5" cy="10" r="2" fill="currentColor"/>
          <circle cx="15" cy="5" r="2" fill="currentColor"/>
          <circle cx="15" cy="15" r="2" fill="currentColor"/>
          <line x1="7" y1="9" x2="13" y2="6" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="7" y1="11" x2="13" y2="14" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'dynamic' 
    },
    { 
      id: 'social-icons', 
      name: 'Social Icons', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="5" cy="10" r="2" fill="currentColor"/>
          <circle cx="10" cy="5" r="2" fill="currentColor"/>
          <circle cx="15" cy="10" r="2" fill="currentColor"/>
          <circle cx="10" cy="15" r="2" fill="currentColor"/>
        </svg>
      ),
      category: 'dynamic' 
    },

    // Form Input Elements
    { 
      id: 'input-text', 
      name: 'Text Input', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="7" width="14" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <text x="10" y="12" textAnchor="middle" fontSize="6">Text</text>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'input-email', 
      name: 'Email Input', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="5" width="14" height="10" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M3 7l7 4 7-4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'input-password', 
      name: 'Password Input', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="7" width="14" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="10" cy="10" r="1.5" fill="currentColor"/>
          <path d="M7 7v-2a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'input-number', 
      name: 'Number Input', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="7" width="14" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <text x="10" y="12" textAnchor="middle" fontSize="7">123</text>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'input-date', 
      name: 'Date Picker', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="4" width="14" height="13" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <line x1="3" y1="8" x2="17" y2="8" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="7" y1="2" x2="7" y2="5" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="13" y1="2" x2="13" y2="5" stroke="currentColor" strokeWidth="1.5"/>
          <text x="10" y="13" textAnchor="middle" fontSize="5">15</text>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'input-time', 
      name: 'Time Picker', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M10 6v4l3 2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'textarea', 
      name: 'Textarea', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="4" width="14" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <line x1="6" y1="8" x2="14" y2="8" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="6" y1="11" x2="12" y2="11" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'select', 
      name: 'Dropdown', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="5" width="14" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M7 7.5l3 2 3-2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="3" y="12" width="14" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'checkbox', 
      name: 'Checkbox', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="8" width="4" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M8 10h9" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'radio', 
      name: 'Radio Button', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="5" cy="10" r="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="5" cy="10" r="1" fill="currentColor"/>
          <path d="M9 10h8" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'toggle', 
      name: 'Toggle Switch', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="8" width="10" height="4" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="7" cy="10" r="2" fill="currentColor"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'range', 
      name: 'Range Slider', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <line x1="3" y1="10" x2="17" y2="10" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="10" cy="10" r="2" fill="currentColor"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'color-picker', 
      name: 'Color Picker', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="10" cy="10" r="3" fill="currentColor"/>
        </svg>
      ),
      category: 'form' 
    },
    { 
      id: 'input-file', 
      name: 'File Upload', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="4" width="14" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M10 7v6M7 10h6" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'form' 
    },

    // Advanced Elements
    { 
      id: 'modal', 
      name: 'Modal', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="4" y="4" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <line x1="8" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="12" y1="8" x2="8" y2="12" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'advanced' 
    },
    { 
      id: 'tooltip', 
      name: 'Tooltip', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="10" cy="8" r="2" fill="currentColor"/>
          <path d="M10 10v5" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'advanced' 
    },
    { 
      id: 'alert', 
      name: 'Alert', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10 2L2 17h16L10 2z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="10" cy="13" r="1" fill="currentColor"/>
          <line x1="10" y1="8" x2="10" y2="11" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'advanced' 
    },
    { 
      id: 'badge', 
      name: 'Badge', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="4" y="8" width="12" height="4" rx="2" fill="currentColor" opacity="0.3"/>
          <text x="10" y="11" textAnchor="middle" fontSize="5">New</text>
        </svg>
      ),
      category: 'advanced' 
    },
    { 
      id: 'code', 
      name: 'Code Block', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="4" width="16" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M7 8L4 10l3 2M13 8l3 2-3 2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'advanced' 
    },
    { 
      id: 'embed', 
      name: 'Embed', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="4" width="16" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <text x="10" y="12" textAnchor="middle" fontSize="5">&lt;/&gt;</text>
        </svg>
      ),
      category: 'advanced' 
    },

    // E-commerce Elements
    { 
      id: 'product', 
      name: 'Product', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="3" y="7" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M6 7V5a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="7" cy="11" r="1" fill="currentColor"/>
          <circle cx="13" cy="11" r="1" fill="currentColor"/>
        </svg>
      ),
      category: 'ecommerce' 
    },
    { 
      id: 'product-grid', 
      name: 'Product Grid', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="2" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="2" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="2" y="11" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="11" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      category: 'ecommerce' 
    },
  ];

  const categories = {
    basic: 'Basic Elements',
    media: 'Media Elements',
    layout: 'Layout Elements',
    dynamic: 'Dynamic Elements',
    form: 'Form Elements',
    advanced: 'Advanced Elements',
    ecommerce: 'E-commerce Elements'
  };
  const groupedWidgets = widgets.reduce((acc, widget) => {
    if (!acc[widget.category]) acc[widget.category] = [];
    acc[widget.category].push(widget);
    return acc;
  }, {});

  return (
    <div className="elementor-sidebar">
      <div className="hstack">
      <button
          className={`w-100 border-bottom border-0 border-muted rounded-0 p-2 ${
            activeTab === "sections" ? "selectedMenu" : "btn-light"
          }`}
          style={{ fontSize: 13 }}
          onClick={() => setActiveTab("sections")}
        >
          📐 Sections
        </button>
        <button
          className={`w-100 border-bottom border-0 border-muted rounded-0 p-2 ${
            activeTab === "widgets" ? "selectedMenu" : "btn-light"
          }`}
          style={{ fontSize: 13 }}
          onClick={() => setActiveTab("widgets")}
        >
          🧩 Widgets
        </button>
      </div>
      
      <div className="sidebar-content">
        {activeTab === "sections" && (
          <div className="sections-library">
            <div className="sections-grid">
              {sectionTemplates.map((section) => (
                <div
                  key={section.id}
                  className="section-template"
                  onClick={() => onAddSection(section.id)}
                >
                  <div className="template-preview">
                    <div className="preview-icon">{section.icon}</div>
                  </div>
                  <div className="template-info">
                    <h4>{section.name}</h4>
                    <p>{section.preview}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "widgets" && (
          <div className="widgets-library">
            {Object.entries(groupedWidgets).map(([category, items]) => (
              <div key={category} className="widget-category">
                <h4>{categories[category]}</h4>
                <div className="widgets-grid">
                  {items.map((widget) => (
                    <div
                      key={widget.id}
                      className="widget-item"
                      draggable
                      onDragStart={(e) => {
                        e.dataTransfer.setData("widgetType", widget.id);
                        e.dataTransfer.effectAllowed = "copy";
                      }}
                      onDragEnd={(e) => {
                        // Optional: handle drag end
                      }}
                    >
                      <div className="widget-icon">{widget.icon}</div>
                      <div className="widget-name">{widget.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ElementorSidebar;